import CardPage from '../../Layouts/CardPage';
import LoginForm from './LoginForm';
import React from 'react';
import { sessionUserContext } from '../../Context/sessionUserContext';
import { Redirect } from 'react-router-dom';

function Login(props){
  const { location } = props;
  const searchParams = new URLSearchParams(location.search);
  const redirectParam = searchParams.get('redirect');
  const redirectPath = redirectParam ? redirectParam : "/";
  return (
    <CardPage title="Sign In">
      <sessionUserContext.Consumer>
        {({logInSession, session, userAccount}) => (
          (session && userAccount) ?
            <Redirect to={redirectPath} /> :
            <LoginForm logInSession={logInSession} />
        )}
      </sessionUserContext.Consumer>
    </CardPage>
  );
}

export default Login;
